import React, { useState, useEffect } from "react";
import { Skeleton, Space, Row, Col, Divider } from "antd";
import { gql, useLazyQuery } from "@apollo/client";
import moment from "moment-jalaali";
import MeetingRoomPackageForm from "./formDetails/meetingRoom";
import WorkSpacePackageForm from "./formDetails/workSpace";

const GETPACKAGE = gql`
  query ($id: ID!) {
    getPackage(id: $id) {
      name
      description
      createdAt
      updatedAt
      packageType
      product{
        name
        id
      }
      days
      sessions
      image
      amountRial
      strikethroughRial
      remider1
      remider2
    }
  }
`;

function PackagesTableDetails({ id, onDataUpdate, onCloseDrawer }) {
  const [initialData, setInitialData] = useState({});
  const [formData, setFromData] = useState(null);

  const [getPackageData, packageData] = useLazyQuery(GETPACKAGE, {
    fetchPolicy: "no-cache",
    onCompleted({ getPackage }) {
      const {
        createdAt,
        updatedAt,
        name,
        packageType,
        product,
        description,
        days,
        sessions,
        image,
        amountRial,
        strikethroughRial,
        remider1,
        remider2,
      } = getPackage;
      const packageData = {
        name,
        packageType,
        product,
        description,
        days,
        sessions,
        image,
        amountRial,
        strikethroughRial,
        remider1,
        remider2,
      };
      setFromData(packageData);

      setInitialData({
        createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        updatedAt: updatedAt && moment(updatedAt).format("jYYYY/jMM/jDD"),
        packageType,
        product
      });
    },
  });
  useEffect(() => {
    if (id) {
      getPackageData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  // const serviceDataUpdated = () => {
  //   getServiceData({
  //     variables: {
  //       id,
  //     },
  //   });
  // };

  const { createdAt, updatedAt, packageType, product } = initialData;

  if (packageData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ ثبت: </p>
            {createdAt}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>آخرین بروزرسانی: </p>
            {updatedAt}
          </Space>
        </Col>
      </Row>
      <Row><h3>پکیج خدمت {product?.name}:</h3></Row>
      <Divider />
      {packageType === "WORK_SPACE" ? (
        <WorkSpacePackageForm
          formData={formData}
          onDoUpdateData={onDataUpdate}
          productId={product?.id}
          packageId={id}
        />
      ) : packageType === "MEETING_ROOM" ? (
        <MeetingRoomPackageForm
          formData={formData}
          onDoUpdateData={onDataUpdate}
          productId={product?.id}
          packageId={id}
        />
      ): null}
    </>
  );
}

export default PackagesTableDetails;
